import React, { useState } from 'react';

import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

import { Popover } from '../../../../components/elements';
import { SITE_URL } from '../../../../constants';

const SocialsPopover = ({ title, url }: { title: string; url: string }) => {
  const { t, i18n } = useTranslation('resources');
  const { language } = i18n;

  const shareUrl = language === 'en' ? `${SITE_URL}${url}` : `${SITE_URL}/${language}${url}`;

  const { socialShare } = t('blog', {
    returnObjects: true,
  }) as any;
  const [showPopover, setShowPopover] = useState<boolean>(false);

  const toggleShowPopover = () => {
    setShowPopover((prev) => !prev);
  };

  const popoverContent = (
    <div>
      <WhatsappShareButton url={shareUrl} title={title}>
        <WhatsappIcon size={21} round={true} />
      </WhatsappShareButton>
      <FacebookShareButton url={shareUrl}>
        <FacebookIcon size={21} round={true} />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title}>
        <TwitterIcon size={21} round={true} />
      </TwitterShareButton>
      <EmailShareButton url={shareUrl}>
        <EmailIcon size={21} round={true} />
      </EmailShareButton>
      <LinkedinShareButton url={shareUrl}>
        <LinkedinIcon size={21} round={true} />
      </LinkedinShareButton>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      title={socialShare.shareTo}
      placement="right"
      open={showPopover}
      onOpenChange={toggleShowPopover}
    >
      <button className="socialShare" aria-label="share via social media">
        <Image
          src="/images/icons/socialMediaShare.svg"
          alt="Social share icon"
          width="16"
          height="16"
        />
      </button>
    </Popover>
  );
};

export default SocialsPopover;
